import { render, staticRenderFns } from "./PrivacySlothysCafe.vue?vue&type=template&id=52c1fb8c&scoped=true"
import script from "./PrivacySlothysCafe.vue?vue&type=script&lang=js"
export * from "./PrivacySlothysCafe.vue?vue&type=script&lang=js"
import style0 from "./PrivacySlothysCafe.vue?vue&type=style&index=0&id=52c1fb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1fb8c",
  null
  
)

export default component.exports